import { useEffect } from 'react'

import { useSessionStore } from '@/lib/auth/session-store'

import { syncExistingWebPushSubscription } from '../push/web-push'

/**
 * Reconciles an already-granted browser push subscription with the API after
 * login. It never prompts and never creates a subscription for a user who had
 * none; see `syncExistingWebPushSubscription`.
 */
export function useWebPushSync(): void {
  const status = useSessionStore((state) => state.status)

  useEffect(() => {
    if (status !== 'authenticated') return
    void syncExistingWebPushSubscription()
  }, [status])
}
